import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {IntlProvider} from 'react-intl';
import {initReactIntl} from './i18n';
import configureStore from './store';
import {Provider} from "react-redux";

/* Configure store. */
const store = configureStore();


const root = ReactDOM.createRoot(document.getElementById('root'));

/* Configure i18n. */
const {locale, messages} = initReactIntl();

root.render(
    <Provider store={store}>
            <IntlProvider locale={locale} messages={messages}>
                <App/>
            </IntlProvider>
    </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
